import { BaseData } from 'types/base.type'
import client from './client'
import { ItemOption } from 'components/FormInputSelect'

class DistrictAttorneyService {
  getAll = async (craai: string): Promise<BaseData<ItemOption[]>> => {
    const url = `/promotoria/${craai}`

    return await client.get<BaseData<ItemOption[]>>(url).then((res) => res)
  }

  buscarTodos = async (): Promise<ItemOption[]> => {
    const url = `/promotoria`

    return await client.get<BaseData<ItemOption[]>>(url).then((res) => res.data)
  }
}

export default new DistrictAttorneyService()
